module.exports = __webpack_public_path__ + "components/weather-icon/static/daypartcloud-847fc76abf42ab87ed412860a97fe16c.png";